import React, { useState } from 'react';
import { IoArrowUpCircleOutline } from 'react-icons/io5';
import { ArrowContainer, Popover } from 'react-tiny-popover';
import { TextInputPopover } from '@/features/editor/widgets/custom-widget/loading-section/shared/text-input-popover';

type Props = { onSaveStrategy: (v: string) => void };

export function SaveStrategyForLater({ onSaveStrategy }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const onSave = (name: string) => {
    setIsOpen(false);
    onSaveStrategy(name);
  };
  return (
    <Popover
      onClickOutside={() => setIsOpen(false)}
      clickOutsideCapture
      positions={[`bottom`, `top`]}
      isOpen={isOpen}
      containerStyle={{ zIndex: `99999` }}
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowColor="white"
          arrowSize={10}
          arrowStyle={{ margin: `1px` }}
        >
          <TextInputPopover
            title="Strategy name"
            onSave={onSave}
            placeholder="Strategy name"
          />
        </ArrowContainer>
      )}
    >
      <button type="button" onClick={() => setIsOpen(!isOpen)}>
        <IoArrowUpCircleOutline size={24} />
        <p>Save Strategy for Later</p>
      </button>
    </Popover>
  );
}
